"use client"

import React from 'react'
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import { LayoutDashboard, Info } from "lucide-react"
import { ENGAGEMENT_TABS, EngagementTab } from "@/types/ui/engagement-view"

export interface EngagementViewToggleProps {
  activeTab: EngagementTab
  onTabChange: (tab: EngagementTab) => void
}

export function EngagementViewToggle({ activeTab, onTabChange }: EngagementViewToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={activeTab}
      onValueChange={(value) => {
        if (value) onTabChange(value as EngagementTab)
      }}
      variant="default"
      size="sm"
      className="border rounded-lg overflow-hidden gap-0"
    >
      <ToggleGroupItem 
        value={ENGAGEMENT_TABS.OVERVIEW}
        className="rounded-r-none border-r-0 h-10 px-4 text-sm font-medium gap-2"
      >
        <LayoutDashboard className="h-4 w-4" fill="currentColor" />
        Overview
      </ToggleGroupItem>
      <ToggleGroupItem 
        value={ENGAGEMENT_TABS.DETAILS}
        className="rounded-l-none h-10 px-4 text-sm font-medium gap-2"
      >
        <Info className="h-4 w-4" />
        Details
      </ToggleGroupItem>
    </ToggleGroup>
  )
}

